/**
 * Ayuda — Compras → Grupos de Proveedores
 */

/** @type {import('../help-index.js').HelpSidebarItem} */
export const ADM_PUR_ENTITY_GROUPS_ITEM = {
  id: 'entityProviderGroups',
  screenId: 'adm-pur-entity-groups',
  label: 'Grupos de Proveedores',
  description: 'Organizá proveedores en categorías y grupos.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Los grupos clasifican proveedores (por rubro, zona, condiciones de pago, etc.). Después los asignás al cargar o editar un proveedor.',
        paragraphs: [
          'Primero creás categorías; después grupos dentro de cada categoría.',
        ],
      },
      {
        title: 'Las dos pestañas de arriba',
        bullets: [
          'Categorías de grupos — define los «contenedores».',
          'Grupos — crea cada grupo y lo vincula a una categoría.',
        ],
        paragraphs: [
          'Desde Compras trabajás con grupos de proveedores.',
        ],
      },
      {
        title: 'Pestaña Categorías',
        bullets: [
          'Lista con descripción, si es para Cliente/Proveedor y si está activa.',
          'Filtro «Solo activos» arriba a la izquierda.',
          'Botón + para categoría nueva; lápiz para editar.',
        ],
        fields: [
          { label: 'Descripción', description: 'Nombre de la categoría. Obligatorio.' },
          { label: 'Proveedor', description: 'Desde Compras suele venir marcado.' },
          { label: 'Cliente', description: 'Marcá si la categoría también sirve para clientes.' },
          { label: 'Activo', description: 'Al editar, podés desactivar sin borrar.' },
        ],
      },
      {
        title: 'Pestaña Grupos',
        bullets: [
          'Lista con descripción, categoría, Cliente/Proveedor y activo.',
          'Botón + para grupo nuevo; lápiz para editar.',
        ],
        fields: [
          { label: 'Categoría', description: 'Elegí en qué categoría va el grupo. Obligatorio.' },
          { label: 'Descripción', description: 'Nombre del grupo. Obligatorio.' },
        ],
      },
      {
        title: 'Uso con proveedores',
        intro:
          'Al cargar o editar un proveedor (menú Proveedores), en «Grupos» marcás a cuáles pertenece.',
      },
    ],
  },
}
